// Number of People filter helper function
export function findCombination(userSentence) {
    let numList = [];
    for (let hour = 1; hour < 24; hour++) {
      for (let minutes = 31; minutes < 40; minutes++) {
        let combinationA = `${hour}${minutes} people`; // e.g. 632 people, 1236 people
        numList.push(combinationA);
        let combinationB = `${hour}:${minutes} people`; // e.g. 7:32 people, 12:33 people
        numList.push(combinationB);
        let combinationC = `${hour}${minutes}, people`; // e.g. 632, people, 1236, people
        numList.push(combinationC);
        let combinationD = `${hour}:${minutes}, people`; // e.g. 7:32, people, 12:33, people
        numList.push(combinationD);
      }
    }
  
    for (let combination of numList) {
      if (userSentence.includes(combination)) {
        return combination;
      }
    }
  
    return "";
  }
  
  // Number of People filter main function
  export function numberOfPeopleFilter(userSentence) {
    let theCombination = findCombination(userSentence.toLowerCase());
    if (theCombination.includes(", people")) {
      theCombination = theCombination.replace(", people", "");
    } else {
      theCombination = theCombination.replace(" people", "");
    }

    const minuteToCheck = [3];
    let userSentenceBefore = "";
  
    if (theCombination) {
      userSentenceBefore = userSentence;
      if (theCombination.length === 3) {
        for (let i = 0; i < minuteToCheck.length; i++) {
          if (theCombination[1] === String(minuteToCheck[i])) {
            let numberOfPeople = theCombination[2];
            let newTime = `${theCombination[0]}:${theCombination[1]}0,`;
            userSentence = userSentence.toLowerCase().replace(theCombination, `${newTime} ${numberOfPeople}`);
            if (userSentence.includes(", people")) {
              userSentence = userSentence.replace(", people", " people");
            }
            return userSentence;
          }
        }
      }
  
      if (theCombination.length === 4) {
        for (let i = 0; i < minuteToCheck.length; i++) {
          if (theCombination[2] === String(minuteToCheck[i])) {
            let numberOfPeople = theCombination[3];
            let newTime = `${theCombination[0]}:${theCombination[2]}0,`;
            userSentence = userSentence.toLowerCase().replace(theCombination, `${newTime} ${numberOfPeople}`);
            if (userSentence.includes(", people")) {
              userSentence = userSentence.replace(", people", " people");
            }
            return userSentence;
          }
        }
      }
  
      if (theCombination.length === 5) {
        for (let i = 0; i < minuteToCheck.length; i++) {
          if (theCombination[3] === String(minuteToCheck[i])) {
            let numberOfPeople = theCombination[4];
            let newTime = `${theCombination.slice(0, 2)}:${theCombination[3]}0,`;
            userSentence = userSentence.toLowerCase().replace(theCombination, `${newTime} ${numberOfPeople}`);
            if (userSentence.includes(", people")) {
              userSentence = userSentence.replace(", people", " people");
            }
            return userSentence;
          }
        }
      }
    }
  
    return userSentence;
  }
